import React from "react";
import { FastField } from "formik";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

const CheckboxComponent = ({
  label,
  row,
  labelPlacement = "end",
  options,
  className,
  category,
  ...props
}) => {
  const onChange = onChangeField => event => {
    if (props.onChange) {
      props.onChange(props.name, event.target.checked);
    }

    event.target.value = event.target.checked;
    onChangeField(event);
  };

  return (
    <FormControl fullWidth>
      <FormControlLabel
        sx={{ mb: 0 }}
        className={className}
        control={
          <FastField type="checkbox" {...props}>
            {({ field }) => (
              <Checkbox {...field} {...props} sx={{ p: 1 }} onChange={onChange(field.onChange)} />
            )}
          </FastField>
        }
        label={
          <Typography color="textSecondary" variant="body2">
            {label}
          </Typography>
        }
      />
    </FormControl>
  );
};

export default React.memo(CheckboxComponent);
